/* The one question left over when somebody is taken off the waiting list.
 *
 * The × on a waiting chip covers two completely different afternoons. Either
 * the desk dealt with the person — walked them over, booked them, took them at
 * the counter — or they got tired of standing there and went somewhere else.
 * The board cannot tell those apart, and until now neither could the day: both
 * left the same `left` row behind and neither reached tt_missed_walkins, so the
 * one number a salon actually staffs off — how many clients we lost today —
 * quietly missed every single person who lost patience in the lobby. They are
 * the likeliest ones to be missed, too: somebody turned away at the door is
 * logged by the desk on the spot, and somebody who waits twenty minutes and
 * leaves is logged by nobody, because nothing happened at the moment they went.
 *
 * So it is asked once, here, while the desk still has them in mind. One
 * question, two answers, and both of them are one press.
 *
 * The removal has ALREADY happened — see `dropCheckin`. Nothing on this sheet
 * puts anybody back on the list or takes anything away, which is why Escape and
 * the scrim are allowed to mean "no": the worst a dismissed sheet costs is a
 * number, and the alternative — a modal that has to be answered before the desk
 * can get back to a client standing in front of them — is how a question
 * becomes something people click through without reading.
 */
import * as Vue from 'vue';
import { store } from '../store.js';

export const CheckinMissed = {
  name: 'CheckinMissed',
  setup: function () {
    return {
      d: store.checkinMissedDetail,
      log: store.logCheckinMissed,
      close: store.closeCheckinMissed
    };
  },
  template: [
    '<div v-if="d" class="modal-scrim" @click.self="close">',
    '  <div class="sheet" role="dialog" aria-modal="true">',
    /* The service's own colour and letter, the same as every sheet about a
       square. It is what the desk recognises the person by on a list where the
       names are strangers' — see the chip in waiting-list.js. */
    '    <div class="sheet__head" :class="{ \'sheet__head--plain\': !d.letter }"',
    '      :style="{ \'--svc\': d.color }">',
    '      <span v-if="d.letter" class="sheet__letter">{{ d.letter }}</span>',
    '      <div>',
    '        <h3>Did {{ d.clientName }} leave without being seen?</h3>',
    '        <p>{{ d.serviceName }} &middot; waited {{ d.waited }}</p>',
    '      </div>',
    '    </div>',
    '',
    '    <div class="assign__section">',
    /* What the yes actually does, in the salon's own terms rather than the
       table's. "Logged as a missed walk-in" means nothing to somebody who has
       not seen the end-of-day report; "counted among the clients you lost
       today" is the thing they would be deciding about. */
    '      <p class="warn-body">A <strong>yes</strong> counts {{ d.clientName }} among today&rsquo;s',
    '        missed walk-ins &mdash; one person, for {{ d.serviceName }}. That is the count the',
    '        day&rsquo;s report reads to say whether the floor was big enough.</p>',
    '      <p class="warn-body">Say <strong>no</strong> if they were seen at the desk, booked in for',
    '        another day, or put on the board by hand. They are off the list either way.</p>',
    '    </div>',
    '',
    '    <div class="sheet__actions">',
    '      <button type="button" class="btn btn--primary btn--lg" @click="log()">',
    '        Yes &mdash; log a missed walk-in</button>',
    '      <button type="button" class="btn btn--quiet" @click="close">',
    '        No, we dealt with them</button>',
    '    </div>',
    '  </div>',
    '</div>'
  ].join('\n')
};
